// Follow-up settings per quote type (batch 3). A type's own value wins; an empty one means "use the default".

export const DEFAULT = 'DEFAULT'

export const CHASE_CALL_OPTIONS = [
  { value: 'AUTO', label: 'Only while this type\'s emails are off (recommended)' },
  { value: 'ALWAYS', label: 'Always' },
  { value: 'NEVER', label: 'Never' }
]

const CHASE_CALL_SHORT = { AUTO: 'While emails off', ALWAYS: 'Always', NEVER: 'Never' }

const WHO = { SALESPERSON: 'The salesperson', CUSTOMER: 'The customer', BOTH: 'Both' }

export function whoLabel(value) {
  return WHO[value] || value || ''
}

/** "7, 21 days" from the type's step days; "no steps" when it has none. */
export function stepDaysText(days) {
  var d = (days || []).filter(n => n !== null && n !== undefined)
  return d.length ? d.join(', ') + ' days' : 'no steps'
}

/** One row of the Quote types table, from GET v1/followupTypes. */
export function typeRow(t) {
  return {
    projectTypeId: t.projectTypeId,
    name: t.name,
    emails: t.emailsOn ? 'On' : 'Off',
    steps: (t.ownSteps ? 'Own: ' : 'Default: ') + stepDaysText(t.stepDays),
    noReply: t.effectiveSilenceEscalationDays + ' days' + (t.silenceEscalationDays === null || t.silenceEscalationDays === undefined ? ' (default)' : ''),
    told: whoLabel(t.effectiveEscalationRecipient) + (t.escalationRecipient ? '' : ' (default)'),
    chaseCall: CHASE_CALL_SHORT[t.chaseCallOnBooking] || ''
  }
}

/** The edit form's model. */
export function toTypeForm(t) {
  var x = t || {}
  var ownDays = x.silenceEscalationDays !== null && x.silenceEscalationDays !== undefined
  return {
    emailsOn: !!x.emailsOn,
    ownSteps: !!x.ownSteps,
    ownSilence: ownDays,
    silenceEscalationDays: ownDays ? x.silenceEscalationDays : x.effectiveSilenceEscalationDays,
    escalationRecipient: x.escalationRecipient || DEFAULT,
    chaseCallOnBooking: x.chaseCallOnBooking || 'AUTO'
  }
}

/** The form as the PUT body: "use the default" is sent as null. */
export function toTypePayload(f) {
  return {
    emailsOn: !!f.emailsOn,
    ownSteps: !!f.ownSteps,
    silenceEscalationDays: f.ownSilence ? f.silenceEscalationDays : null,
    escalationRecipient: f.escalationRecipient && f.escalationRecipient !== DEFAULT ? f.escalationRecipient : null,
    chaseCallOnBooking: f.chaseCallOnBooking || 'AUTO'
  }
}
